// Apolo IDE — background ZeroEntropy index on session open.
//
// Ensures Vectorize has embeddings before the agent calls semantic_search.
// Rebuilds at most once every 6h per repo root (localStorage marker).

import { useEffect } from 'react';
import { hasElectronBridge } from '../lib/electronBridge.js';
import {
  rebuildSemanticIndex,
  shouldAutoRebuildIndex,
} from '../lib/semanticIndexClient.js';

/**
 * @param {string|undefined} sessionId
 * @param {string|undefined} root — absolute worktree path
 */
export function useSemanticIndexAutoLoad(sessionId, root) {
  useEffect(() => {
    if (!sessionId || !root?.startsWith('/')) return undefined;
    if (!hasElectronBridge()) return undefined;
    if (!shouldAutoRebuildIndex(root)) return undefined;

    let cancelled = false;
    (async () => {
      const res = await rebuildSemanticIndex(sessionId, root);
      if (cancelled || !res.ok) return;
      if (typeof window !== 'undefined' && window.console) {
        window.console.info('[zeroentropy] auto-index concluído', { root, chunks: res.chunks });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [sessionId, root]);
}
